export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a plantillas"])},
          "quality_inspects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de Calidad"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inspecciones"])},
          "general_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar Reporte Excel"])},
          "view_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to templates"])},
          "quality_inspects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality Inspections"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inspections"])},
          "general_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download Excel Report"])},
          "view_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["See"])}
        }
      }
    }
  })
}